export const BRAND_MAP = {
  ipro: "i-PRO",
  atsumi: "アツミ電氣",
  tplink: "TP-Link",
};
